import { PaginatedRequest } from '../types/api';
import {
  ReconciliationRunDetailResponse,
  ReconciliationRunExportResponse,
  ReconciliationRunItemDetailResponse,
  ReconciliationRunResponse,
} from '../types/reconciliation';
import { toQueryParams } from '../utils/request';
import { ApiService } from './common/ApiService';

class ReconciliationService extends ApiService {
  pathname = 'admin';

  /** GET /admin/reconciliation/runs/:orderId — paginated runs for a portfolio order */
  fetchReconciliationRuns = async (data: PaginatedRequest & { orderId: string }) => {
    const { orderId, ...query } = data;
    const qs = toQueryParams(query);
    const path = `${this.pathname}/reconciliation/${encodeURIComponent(orderId)}/runs`;
    return this.get<ReconciliationRunResponse>(qs ? `${path}?${qs}` : path);
  };

  fetchReconciliationRunDetail = async (runId: number) =>
    this.get<ReconciliationRunDetailResponse>(`${this.pathname}/reconciliation/runs/${runId}`);

  /** GET /admin/reconciliation/runs/:runId/export — returns JSON; client builds CSV / Excel. */
  fetchReconciliationRunExport = async (runId: number) =>
    this.get<ReconciliationRunExportResponse>(`${this.pathname}/reconciliation/runs/${runId}/export`);

  /** GET /admin/reconciliation/runs/:runId/items/:itemId — item + comparisons */
  fetchReconciliationRunItemDetail = async (runId: number, itemId: number) =>
    this.get<ReconciliationRunItemDetailResponse>(`${this.pathname}/reconciliation/runs/${runId}/items/${itemId}`);
}

export const reconciliationService = new ReconciliationService();
